import { InjectionKey } from 'vue';
import { RetailerImportMappingItemsViewService } from '../services/retailer-import-mapping-items-view.service';

export const importMappingItemsServiceKey =
  Symbol() as InjectionKey<RetailerImportMappingItemsViewService>;
